export class Colors {
  static readonly colors: string[] = new Array("#93D230", "#0088AA", "#C03B30", "#d42ca7"); // železnice, autobusy, MHD, uživatel
}
